import classNames from "classnames";
// import localFont from "next/font/local";

// FIXME: Does not work in storybook
// const montFont = localFont({
//     src: "../../fonts/Mont-Trial-Bold.ttf",
//     fallback: ["font-mont"],
// });

export const SecondaryTitle = ({ children, className }) => {
    return (
        <div
            className={classNames(
                "font-mont",
                // montFont.className,
                "text-3xl font-bold leading-[33.60px]",
                "w-80 text-[#001c3d]",
                className
            )}>
            {children}
        </div>
    );
};
